import { Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useMemo } from "react";

export const DescFormItem = () => {
  const rules = useMemo(
    () => [
      {
        max: 100,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  return (
    <Form.Item
      className="w-100"
      label="Description"
      name="description"
      rules={rules}
    >
      <TextArea rows={2} className="ticklers-type-form-textarea" />
    </Form.Item>
  );
};
